(function () {
    'use strict';

    const ibBasketSection = {
        controller: 'ibBasketSectionController',
        controllerAs: 'basketSectionCtrl',
        templateUrl: ['$rootScope', function ($rootScope) {
            return $rootScope.routes.templates + 'ib-basket-section-module.html';
        }],
        bindings: {
            model: '=',
            basketFunctions: '=',
            deleteFlag: '=',
            loadingVoucher: '='
        }
    };

    angular
        .module('ib-basket-section')
        .component('ibBasketSection', ibBasketSection);
})();